export const SET_CATEGORIES_PRODUTOS = 'SET_CATEGORIES_PRODUTOS'
export const SET_PRODUTOS_BY_CATEGORIE = 'SET_PRODUTOS_BY_CATEGORIE'
export const SET_QUANTITY_PRODUTOS_BY_CATEGORIE = 'SET_QUANTITY_PRODUTOS_BY_CATEGORIE'
export const SET_CHOICED_PRODUCT = 'SET_CHOICED_PRODUCT'
export const SET_ALL_PRODUCTS = 'SET_ALL_PRODUCTS'



